
/**
 * Cinproducts
 */
{
    var $finder = null;
    var $finderOverlay = null;
    var $finderTimer = null;


    /**
     * Leert die Findereingaben und löscht das Cookie
     */
    function resetFinder() {
        $.removeCookie('productfinder', {path: '/'});
        $('input[type="checkbox"]').prop('checked', false);

        var $trolleys = $('#trolleys');
        var $roomHeight = $('#room_height');

        $trolleys.bootstrapSlider('setValue', $trolleys.data('slider-value'));
        $roomHeight.bootstrapSlider('setValue', $roomHeight.data('slider-value'));

        $.removeCookie('productfinder', {path: '/'});
    }


    /**
     * Speichert Finder als Cookie
     */
    function saveFinderToCookie() {
        var saveCookie = {};

        // Speichert alle angeklickten Processe
        var processes = [];

        $('input[name="tx_cinproducts_productfinder[finder][processes][]"]:checked').each(function () {
            processes.push($(this).val());
        });

        // Speichert alle angeklickten Automatisierungsgrade
        var automations = [];

        $('input[name="tx_cinproducts_productfinder[finder][automations][]"]:checked').each(function () {
            automations.push($(this).val());
        });

        saveCookie.processes = processes;
        saveCookie.automations = automations;
        saveCookie.trolleys = $('input#trolleys').val();
        saveCookie.room_height = $('input#room_height').val();

        $.cookie("productfinder", JSON.stringify(saveCookie), {expires: 365, path: '/'});
    }


    /**
     * Lädt Finderdaten aus Cookie
     */
    function loadFinderFromCookie() {

        var cookieLoad = $.cookie("productfinder");
        if (cookieLoad) {
            var cookie = JSON.parse(cookieLoad);

            // Lädt alle Processe aus dem Cookie
            if (cookie.processes) {
                $(cookie.processes).each(function (index, value) {
                    $('input[name="tx_cinproducts_productfinder[finder][processes][]"][value="' + value + '"]').prop('checked', true);
                });
            }

            // Lädt alle Automatisierungsgrade aus dem Cookie
            if (cookie.automations) {
                $(cookie.automations).each(function (index, value) {
                    $('input[name="tx_cinproducts_productfinder[finder][automations][]"][value="' + value + '"]').prop('checked', true);
                });
            }

            if (cookie.trolleys > 0) {
                $('#trolleys').bootstrapSlider('setValue', cookie.trolleys);
            }

            if (cookie.room_height > 0) {
                $('#room_height').bootstrapSlider('setValue', cookie.room_height);
            }
        }
    }


    /**
     * Öffnet den Produktfinder
     */
    function openFinder() {
        clearFinderTimer();
        $("body").addClass("noscroll");
        var duration = (isMobileScreen() ? 300 : 500);
        $finderOverlay.fadeIn(duration, function() {
            $(this).addClass("active");
            $finder.addClass("open");
        });
    }

    /**
     * Schließt den Produktfinder
     */
    function closeFinder() {
        unpromoteFinder();
        $finder.removeClass("open");
        $("body").removeClass("noscroll");
        if (isMobileScreen()) {
            $finderOverlay.removeClass("active").fadeOut(500);
            $('html,body').animate({ scrollTop: 0 }, 500);
        } else {
            $finderOverlay.removeClass("active").delay(1000).fadeOut(200);
        }
    }

    /**
     * Öffnet oder schließt den Produktfinder je nach Zustand.
     */
    function toggleFinder() {
        if ($finder.hasClass('open')) {
            closeFinder();
        } else {
            openFinder();
        }
    }


    /**
     * Lässt die Finderlasche etwas herauskommen um darauf aufmerksam zu machen.
     */
    function promoteFinder() {
        if ($finder.is(":visible")) {
            $finder.addClass("promo");
            setupFinderTimer(unpromoteFinder, 5000); // 3 sec.
        }
    }

    /**
     * Gegenteil von promoteFinder() ;-).
     */
    function unpromoteFinder() {
        $finder.removeClass("promo");
        setupFinderTimer(promoteFinder, 8000); // 8 sec.
    }


    /**
     * Beendet/Löscht das aktuelle Promo Timeout für den Produktfinder.
     */
    function clearFinderTimer() {
        if ($finderTimer) {
            window.clearTimeout($finderTimer);
        }
    }

    /**
     * Richtet ein Timeout für den Produktfinder (neu) ein.
     * Ein bereits bestehendes Timeout wird zuvor beendet und dann ersetzt.
     *
     * @param callback
     * @param delay
     */
    function setupFinderTimer(callback, delay) {
        clearFinderTimer();
        $finderTimer = window.setTimeout(callback, delay);
    }


    /**
     * Phone screen size
     *
     * @returns {boolean}
     */
    function isPhoneScreen() {
        return ($(window).width() < 768);
    }

    /**
     * Tablet screen size
     *
     * @returns {boolean}
     */
    function isTabletScreen() {
        return ($(window).width() >= 768 && $(window).width() < 992);
    }

    /**
     * Mobile screen size
     *
     * @returns {boolean}
     */
    function isMobileScreen() {
        return ($(window).width() < 992);
    }


    $(document).ready(function () {

        $finder         = $('#finder');
        $finderOverlay  = $('#finder-overlay');


        // Blendet die Tab bezogenen Bilder in der rechten Spalte ein
        $('.cinproducts-detail').find("a[data-toggle='tab']").on("shown.bs.tab", function() {

            // Search for Tab-Images
            var href = $(this).attr('href');
            var $content2 = $('#content2');
            var $contentDefault  = $content2.find('.content-default');
            var $contentSketches = $content2.find('.content-sketches');

            if (href === '#tab-technical-data') {
                $contentDefault.hide();
                $contentSketches.fadeIn(300);
            } else {
                $contentSketches.hide();
                $contentDefault.fadeIn(300);
            }
        });


        // Setzt die Slider um
        var $trolleys = $('#trolleys');
        if ($trolleys.length > 0) {
            $trolleys.bootstrapSlider({
                tooltip: 'hide',
                formatter: function(value) {

                    var dataUids   = $trolleys.data("sliderUids");
                    var dataLabels = $trolleys.data("sliderTicksLabels");

                    $('#trolleys_output').html(dataLabels[value]);
                    $('#trolleys_range').val(dataUids[value]);

                    return value;
                }
            });
        }

        $('#room_height').bootstrapSlider({
            tooltip: 'hide',
            formatter: function(value) {
                $('#room_height_output').html(value);
            }
        });


        // Lädt Cookie
        loadFinderFromCookie();


        // Finder Form
        var $finderForm = $("form#finder-form");

        // Reset alle Findereingaben
        $finderForm.find('.clear').click(function() {
            resetFinder();
        });


        $finderForm.submit(function(e) {
            e.preventDefault();

            var $form = $(this);
            var url = window.location.origin + $form.attr('action');

            // Serialisiert die Eingaben aus dem Formular
            var postString = $form.serialize();

            // Speichert Cookie
            saveFinderToCookie();

            // Reset Finder Result List
            var $finderResultContainer = $('#cinproducts-finder-result');
            $finderResultContainer.find(".finderResultList").slick("unslick");
            $finderResultContainer.html('<div class="loader"></div>');

            // Bei Handys
            if (isPhoneScreen()) {
                // Etwas herunterscrollen
                $('html,body').animate({ scrollTop: 786 }, 500);
            }

            // Bei Handys und Tablets
            if (isMobileScreen()) {
                // Focus von buttons entfernen
                $form.find("button").blur();
            }


            $.ajax({
                type: "POST",
                url: url,
                data: postString,
                success: function(data) {
                    var $finderResultContainer = $('#cinproducts-finder-result');
                    $finderResultContainer.html(data);
                    $finderResultContainer.find(".finderResultList").slick({
                        adaptiveHeight: false,
                        slidesToShow: 1,
                        slidesPerRow: 2,
                        rows: 2,
                        arrows: true,
                        prevArrow: '<button type="button" class="slick-prev"></button>',
                        nextArrow: '<button type="button" class="slick-next"></button>',
                        dots: true,
                        customPaging: function() {
                            return "&nbsp;";
                        },
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesPerRow: 1,
                                    rows: 100,
                                    arrows: false
                                }
                            }
                        ]
                    });
                },
                error: function() {
                    alert("Es ist ein Fehler aufgetreten");
                }
            });

        });


        $finder.hide();
        $finder.find("#finder-strap")
            .click(toggleFinder)
            .hover(promoteFinder, unpromoteFinder);


        $finderOverlay.click(function() {
            if ($(this).hasClass("active")) {
                closeFinder();
            }
        });


        // Klick auf Menüpunkt "Produktfinder"
        var $menuProductFinder = $('a[target="productfinder"]');
        if ($menuProductFinder.length > 0) {
            $menuProductFinder.click(function(e) {
                e.preventDefault();
                openFinder();
            });
        }


        // Finder je nach Scrollposition ein-/ausblenden
        window.setInterval(function() {
            if (isMobileScreen()) {
                if ($finder.is(":hidden")) {
                    $finder.fadeIn(500);
                    promoteFinder();
                }
            } else {
                // var $section = $("main").children(".section.blue").eq(0);
                var $section = $("main").eq(0);
                if ($section.length === 1) {
                    var offset = $section.offset();
                    var scrollY = $(this).scrollTop();
                    var minY = (offset.top - 320);
                    var maxY = (minY + $section.height() - 300);

                    if (maxY > minY) {
                        if (scrollY >= minY && scrollY <= maxY) {
                            if ($finder.is(":hidden")) {
                                $finder.fadeIn(500);
                                promoteFinder();
                            }
                        } else if ($finder.is(":visible")) {
                            unpromoteFinder();
                            $finder.fadeOut(500);
                        }
                    }
                }
            }

        }, 100);

    });

}
